export default "__VITE_ASSET__CYCnm8TA__"